<div
    class="popup-body cards mybetscontent"
    msScrolledToBottom
    [class.mybetsdetails-nonepcot]="!isEpcotEnabled"
    [scrollContext]="scrollContext"
    (scrollAtBottom)="loadMore()">
    @if (canBeFiltred) {
        <ms-my-bets-filter
            [inColumn]="inColumn"
            [filterConstraint]="filterConstraint"
            [myBetsListContext]="myBetsListContext"
            [betslipsCount]="betslipsCount"
            (filterChanged)="onFilterChanged($event)" />
    } @else {
        <ms-arc-message />
    }
    <div id="betslips-list-wrapper">
        @for (group of groups; track group) {
            <div class="betslip-column">
                @for (column of group.columnsArray; track column.betslipsCount) {
                    <ms-my-bets-list-column
                        [betslips]="column.betslips"
                        [class.betslip-date]="hasDateSeparators"
                        [myBetsListContext]="myBetsListContext"
                        [hasDateSeparators]="hasDateSeparators"
                        [oneColumn]="inColumn || columns === 1" />
                }
            </div>
        }
    </div>

    @if (betslips.length === 0 && filterConstraint && filterConstraint.constraints.length > 0) {
        <div class="mybets-empty mybets-filter-no-bets">
            <div class="mybets-empty-header">
                @if (emptyBetsImg) {
                    <img priority [ngSrc]="emptyBetsImg.src" [width]="emptyBetsImg.width" [height]="emptyBetsImg.height" [alt]="emptyBetsImg.alt" />
                } @else {
                    <vn-icon class="mybets-empty-header_icon" name="theme-mybet-emptystate" size="80" />
                }
                <span class="mybets-empty-header_label">{{ sitecore.myBets_FilterView.NoBetsForFilter }}</span>
                <div class="mybets-filter-no-bets__reset-button">
                    <button class="btn ghost-btn" (click)="onResetFilter()">{{ sitecore.myBets_FilterView.NoBetsResetButtonTitle }}</button>
                </div>
            </div>
        </div>
    }
</div>
